module.exports = __webpack_public_path__ + "static/media/icon-info.6448a8d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-info.svg
// module id = 1242
// module chunks = 19